<template>
    <div data-testid="financialclose-project-users" class="all-height d-flex justify-center">
        <div class="all-width">
            <v-card data-testid="financialclose-project-users__card" class="all-height all-width shadow-off" loader-height="2" :loading="loading" :disabled="loading">
                <v-card-text data-testid="financialclose-project-users__first-cycle" v-if="isFirst">
                    <div>
                        <v-row>
                            <v-col class="text-h1 text-center">
                                <div data-testid="financialclose-project-users__intro-title" class="">Let us get started on setting up a close cycle</div>
                            </v-col>
                        </v-row>
                        <br>
                        <div data-testid="financialclose-project-users__intro-actions" class="text-center font-weight-bold text-decoration-underline">
                            <v-btn data-testid="financialclose-project-users__get-started-btn" color="black " class="white--text"
                                @click="$nova.gotoLink({ path: '/financialclose/project/trialbalance/' + id })">
                                <span>Get Started</span>
                            </v-btn>
                        </div>
                    </div>
                </v-card-text>
                <v-card-text data-testid="financialclose-project-users__content" v-else>


                    <div data-testid="financialclose-project-users__header" class="d-flex flex-column">
                        <div class="">
                            <div class="d-flex">
                                <p data-testid="financialclose-project-users__breadcrumb-home" class="mb-1 cursor-pointer" @click="$nova.gotoLink({ path: `/financialclose/project/dashboard/`+id })">Home</p>
                                <p class="px-2 mb-1">/</p>
                                <p data-testid="financialclose-project-users__breadcrumb-description" class="mb-1">{{ metadata.description }}</p>
                            </div>
                            <div class="d-flex align-center justify-start">
                                <h3 data-testid="financialclose-project-users__title" class="black--text font-weight-semibold ma-0">Dashboard</h3>
                                
                                    <v-tooltip bottom content-class="tooltip-bottom" >
                                        <template v-slot:activator="{ on, attrs }"> 
                                            <v-btn data-testid="financialclose-project-users__refresh-btn"
                                                v-bind="attrs"
                                                v-on="on"
                                                class="shadow-off ml-1" icon @click="refreshData()"><v-icon
                                                size="24">mdi-refresh</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Refresh</span>
                                      </v-tooltip>
                                    <!-- INFO: Temporary the activity log button is disabled, should be enabled later. So do not remove the code -->
                                    <!-- <lb-activitysidemenuNew data-testid="financialclose-project-users__activity-log" :config="activitylogconfig"
                                        :url="`/v2/financialclose/project/getlogs/${metadata._id}`" /> -->
                                    <v-tooltip bottom content-class="tooltip-bottom"  v-if="clientNotification">
                                        <template v-slot:activator="{ on, attrs }"> 
                                            <v-btn data-testid="financialclose-project-users__open-email-dialog-btn"
                                                v-bind="attrs"
                                                v-on="on"
                                                class="shadow-off" icon @click="emailpop()"><v-icon
                                                size="24">mdi-email-sync</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Email</span>
                                    </v-tooltip>
                            </div>
                        </div>

                        <div class="filterlists" v-if="!initialLoading">
                            <div data-testid="financialclose-project-users__filters-container" class="border-on d-flex shadow-on radius-small">
                                <div data-testid="financialclose-project-users__filter-country" class="text-center px-4 py-2 hoverable">
                                <div data-testid="financialclose-project-users__filter-country-label" class="grey--text text--darken-1 line-1">Country</div>
                                <div class="font-weight-bold">
                                    <v-menu offset-y open-on-hover v-if="activeCountryList?.length > 0">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div data-testid="financialclose-project-users__filter-country-activator" class="filter-hide cursor-pointer" v-bind="attrs" v-on="on">
                                                <span data-testid="financialclose-project-users__filter-country-value">{{ selectedCountryDisplayText }}</span>
                                                <v-icon class="">mdi-chevron-down</v-icon>
                                            </div>
                                        </template>
                                        <perfect-scrollbar style="max-height: 300px">
                                            <v-list data-testid="financialclose-project-users__country-list" dense class="pa-0 border-left-default">
                                                <v-list-item data-testid="financialclose-project-users__country-select-all" @click="selectAllCountries()">
                                                    <v-list-item-title class="font-weight-bold">{{ UI_TEXT.SELECT_ALL }}</v-list-item-title>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <v-list-item 
                                                    v-for="(v, k) in activeCountryList" 
                                                    :key="k" 
                                                    data-testid="financialclose-project-users__country-item" 
                                                    @click="filterAllloaction(v,selectedUserName); selectedCOuntryname = v"
                                                    :disabled="isCountryDisabled(v.country)"
                                                    :class="{ 'disabled-item': isCountryDisabled(v.country) }">
                                                    <v-list-item-title class="noTransform">{{ v.country }}</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </perfect-scrollbar>
                                    </v-menu>
                                    <span v-else>NA</span>
                                </div>
                            </div>
                            <div data-testid="financialclose-project-users__filter-location" class="text-center px-4 py-2 hoverable">
                                <div data-testid="financialclose-project-users__filter-location-label" class="grey--text text--darken-1 line-1">{{ $store.state.LocationHeader ? $store.state.LocationHeader : 'Location' }}</div>
                                <div class="font-weight-bold">
                                    <v-menu offset-y v-if="activeLocationsList?.length > 0" :close-on-content-click="false" :key="locationMenuKey">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div data-testid="financialclose-project-users__filter-location-activator" class="filter-hide cursor-pointer noTransform" v-bind="attrs" v-on="on">
                                                <span data-testid="financialclose-project-users__filter-location-value">{{ selectedLocationDisplayText }}</span>
                                                <v-icon class="">mdi-chevron-down</v-icon>
                                            </div>
                                        </template>
                                        <perfect-scrollbar style="max-height: 300px">
                                            <v-list data-testid="financialclose-project-users__location-list" dense class="pa-0 border-left-default">
                                                <v-list-item @click="toggleSelectAllLocations()" :key="'all'">
                                                    <v-list-item-action class="mr-2">
                                                        <v-checkbox 
                                                            :input-value="isAllLocationsSelected" 
                                                            @click.stop="toggleSelectAllLocations()"
                                                            hide-details
                                                            dense
                                                        ></v-checkbox>
                                                    </v-list-item-action>
                                                    <v-list-item-title>All</v-list-item-title>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <v-list-item 
                                                    v-for="(v, k) in activeLocationsList" 
                                                    :key="k" 
                                                    data-testid="financialclose-project-users__location-item" 
                                                    @click="toggleLocationSelection(v)"
                                                    :disabled="isLocationDisabled(v.id)"
                                                    :class="{ 'disabled-item': isLocationDisabled(v.id) }">
                                                    <v-list-item-action class="mr-2">
                                                        <v-checkbox 
                                                            :input-value="isLocationSelected(v)" 
                                                            @click.stop="toggleLocationSelection(v)"
                                                            hide-details
                                                            dense
                                                            :disabled="isLocationDisabled(v.id)"
                                                        ></v-checkbox>
                                                    </v-list-item-action>
                                                    <v-list-item-title class="noTransform">{{ v.name || 'NA' }}</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </perfect-scrollbar>
                                    </v-menu>
                                    <span v-else>All</span>
                                </div>
                            </div>
                            <div data-testid="financialclose-project-users__filter-user" class="text-center px-4 py-2 hoverable" v-if="managerlist.indexOf(userid) > -1">
                                <div data-testid="financialclose-project-users__filter-user-label" class="grey--text text--darken-1 line-1">Users</div>
                                <div class="font-weight-bold">
                                    <v-menu offset-y open-on-hover v-if="userlist?.length > 1">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div data-testid="financialclose-project-users__filter-user-activator" class="filter-hide cursor-pointer" v-bind="attrs" v-on="on">
                                                <span data-testid="financialclose-project-users__filter-user-value">{{ selectedUserDisplayText }}</span>
                                                <v-icon class="">mdi-chevron-down</v-icon>
                                            </div>
                                        </template>
                                        <perfect-scrollbar style="max-height: 300px">
                                            <v-list data-testid="financialclose-project-users__user-list" dense class="pa-0 border-left-default">
                                                <v-list-item data-testid="financialclose-project-users__user-select-all" @click="selectAllUsers()">
                                                    <v-list-item-title class="font-weight-bold">{{ UI_TEXT.SELECT_ALL }}</v-list-item-title>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <v-list-item 
                                                    v-for="(v, k) in userlist" 
                                                    :key="k" 
                                                    data-testid="financialclose-project-users__user-item"  
                                                    @click="filterselectedloactionanduser(selectedCOuntryname,selectedLocationName,v);selectedUserName=v">
                                                    <v-list-item-title class="noTransform">{{ v.name }}</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </perfect-scrollbar>
                                    </v-menu>
                                    <span v-else>NA</span>
                                </div>
                            </div>
                            <div>
                                <lb-divider type="vertical"></lb-divider>
                            </div>
                            <div data-testid="financialclose-project-users__filter-reset" class="text-center py-2 px-1 hoverable">
                                <div>
                                    <v-tooltip bottom content-class="tooltip-bottom">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                data-testid="financialclose-project-users__reset-filters-btn" 
                                                :class="{ 'primary': hasActiveFilter }" 
                                                :dark="hasActiveFilter" 
                                                icon 
                                                v-bind="attrs" 
                                                v-on="on" 
                                                @click.stop="resetFilter()">
                                                <v-icon>{{ hasActiveFilter ? 'mdi-filter-remove' : 'mdi-close' }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Reset filters</span>
                                    </v-tooltip>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <!-- Skeleton Loader for Initial Loading -->
                    <div data-testid="financialclose-project-users__skeleton-loader" v-if="initialLoading">
                        <v-row>
                            <v-col cols="6">
                                <v-skeleton-loader type="text, text" class="mb-2"></v-skeleton-loader>
                                <v-skeleton-loader type="text" height="12"></v-skeleton-loader>
                            </v-col>
                            <v-col cols="6">
                                <v-skeleton-loader type="text, text" class="mb-2"></v-skeleton-loader>
                                <v-skeleton-loader type="text" height="12"></v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col v-for="n in 6" :key="n" cols="2">
                                <v-skeleton-loader type="card" height="200"></v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12">
                                <v-skeleton-loader type="table-heading, table-row-divider@5"></v-skeleton-loader>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- Dashboard Content -->
                    <div data-testid="financialclose-project-users__dashboard" v-if="!initialLoading && metadata._id">
                        <v-row>
                            <v-col cols="6">
                                <div data-testid="financialclose-project-users__tasklist-progress" class="mb-2 ">
                                    <div class="d-flex align-center mb-1">
                                        <h1 data-testid="financialclose-project-users__tasklist-progress-value" class="mr-2 font-weight-medium">
                                            {{ summary.checklist?.total?.[type] || 0 }}%
                                        </h1>
                                        <div data-testid="financialclose-project-users__tasklist-progress-labels" class="">
                                            <div data-testid="financialclose-project-users__tasklist-title" class="line-1-2"><h4 class="font-weight-medium">Tasklist</h4></div>
                                            <div data-testid="financialclose-project-users__tasklist-overall" class="line-1-2"><h6 class="font-weight-regular">Overall Progress</h6></div>
                                        </div>
                                    </div>
                                    <v-progress-linear data-testid="financialclose-project-users__tasklist-progress-bar" :value="((summary.checklist?.total?.[type] || 0)) || 0.5"
                                        color="green" height="12"></v-progress-linear>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div data-testid="financialclose-project-users__pbc-progress" class="mb-2">
                                    <div class="d-flex align-center mb-1">
                                        <h1 data-testid="financialclose-project-users__pbc-progress-value" class="mr-2 font-weight-medium">
                                            {{ (summary.pbc?.total?.[type] || 0) }}%
                                        </h1>
                                        <div data-testid="financialclose-project-users__pbc-progress-labels" class="">
                                            <div data-testid="financialclose-project-users__pbc-title" class="line-1-2"><h4 class="font-weight-medium">Information Requests</h4></div>
                                            <div data-testid="financialclose-project-users__pbc-overall" class="line-1-2"><h6 class="font-weight-regular">Overall Progress</h6></div>
                                        </div>
                                    </div>
                                    <v-progress-linear data-testid="financialclose-project-users__pbc-progress-bar" :value="((summary.pbc?.total?.[type] || 0)) || 0.5"
                                        color="black lighten-1" height="12"></v-progress-linear>
                                </div>
                            </v-col>
                            <!-- <v-col cols="12">
                                <div>
                                    <span class="font-weight-bold mr-1">Note:</span>
                                    <span>The components depicted below are based on the Chart of Accounts and the Trial
                                        Balance uploaded.
                                        In case there is no linkage or no trial balance is uploaded then all of the
                                        metrics would get
                                        categorised as part of Others.</span>
                                </div>
                            </v-col> -->

                            <v-col v-for="(v, k) in keytypes" :key="k" data-testid="financialclose-project-users__category-col" cols="2">
                                    <div data-testid="financialclose-project-users__category-card" :class="`pa-4 radius-on text-center cursor-pointer ${(selected === k) ? '' : 'hoverable'}`"
                                        @click="selected = k">
                                        <h5 data-testid="financialclose-project-users__category-name" class="font-weight-medium mb-2">{{ v.name }}</h5>
                                        <v-progress-circular data-testid="financialclose-project-users__category-progress" :rotate="270" :size="120" :width="22"
                                            :value="((summary.checklist?.[k]?.[type] || 0)) || 1" :color="v.color"
                                            class="title font-weight-bold">
                                            {{ (summary.checklist?.[k]?.[type] || 0) }}%
                                        </v-progress-circular>
                                        <div class="mt-4">
                                            <div></div>
                                        </div>
                                        <div data-testid="financialclose-project-users__category-pbc" class="text-left d-flex align-center">
                                            <div data-testid="financialclose-project-users__category-pbc-value" class="title mr-2">
                                                {{ (summary.pbc?.[k]?.[type] || 0) }}%
                                            </div>
                                            <h6 data-testid="financialclose-project-users__category-pbc-label" class="line-1 font-weight-regular">
                                                Information Requests</h6>
                                        </div>
                                        <v-progress-linear data-testid="financialclose-project-users__category-pbc-bar" :value="((summary.pbc?.[k]?.[type] || 0)) || 2"
                                            color="primary lighten-1 rounded-0" height="12"></v-progress-linear>
                                    </div>
                            </v-col>
                           
                            <v-col data-testid="financialclose-project-users__category-summary" cols="12" v-if="tddata.length !==0 && selected" class="d-flex justify-center">
                                <div class="radius-on category-summary-container">
                                    <div class="d-flex align-center mb-2">
                                        <v-btn data-testid="financialclose-project-users__back-to-categories-btn" icon class="mr-2" v-if="tddata.length !== 0 && selected"
                                            @click="selected = ''"><v-icon>mdi-arrow-left</v-icon></v-btn>
                                        <span data-testid="financialclose-project-users__category-summary-title" class="body-2 font-weight-bold">Tasklist Category wise summary</span>
                                    </div>

                                    <div class="category-summary-table-wrapper">
                                        <template v-if="(summary.checklist?.[selected]?.category_detail || []).length > 0">
                                            <lb-datatableaction data-testid="financialclose-project-users__category-summary-table" :headers="tableheaders" :tabledata=" (summary.checklist?.[selected]?.category_detail || [])"
                                            :itemsperpage="categoryTableItemsPerPage" searchterm="" :bulkActions="false">

                                            <template v-slot:tbody>
                                                <tr data-testid="financialclose-project-users__category-summary-row" v-for="item in (summary.checklist?.[selected]?.category_detail || [])" :key="item._id" :class="{ 'low-opacity': item.status === false }">
                                                    <td v-for="header in tableheaders" :key="header.value">
                                                        {{ item[header.value] }}
                                                    </td>
                                                </tr>
                                            </template>

                                            </lb-datatableaction>
                                        </template>
                                        <div v-else data-testid="financialclose-project-users__category-summary-no-data" class="empty-state pa-6 text-center grey--text">
                                            <v-icon size="48" class="mb-2 grey--text text--lighten-1">mdi-table-off</v-icon>
                                            <div>No data found</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>

                            <v-col data-testid="financialclose-project-users__default-summary" cols="12" v-if="( ! Object.keys(selectedCOuntryname).length > 0 && selectedLocationName.length === 0  && ! Object.keys(selectedUserName).length > 0)" >
                                <div data-testid="financialclose-project-users__default-category" v-for="(item, index) in defaultabledata" :key="index" class="mb-6">
                                <h4 data-testid="financialclose-project-users__default-category-title" class="font-weight-medium mb-3">{{ item.category }}</h4>
                                <v-simple-table data-testid="financialclose-project-users__default-table" dense class="border-on">
                                    <thead class="tableHeaderBg">
                                    <tr>
                                        <th data-testid="financialclose-project-users__default-th-subcategory" class="">Subcategory</th>
                                        <th data-testid="financialclose-project-users__default-th-duedate" class="">Due Date</th>
                                        <th data-testid="financialclose-project-users__default-th-country" class="" v-for="(country, Indexcon) in uniqueCountries" :key="Indexcon">{{country}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr data-testid="financialclose-project-users__default-row" v-for="(sub, subIndex) in item.subcategories" :key="subIndex">
                                        <td data-testid="financialclose-project-users__default-cell-subcategory" class="fixed-width-filter">{{sub.subcategory}}</td>
                                        <td data-testid="financialclose-project-users__default-cell-duedate" class="fixed-width ellipsis-on" >{{sub.duedate}}</td>
                                        <td data-testid="financialclose-project-users__default-cell-country" class="fixed-width" v-for="(country, Indexcon) in uniqueCountries" :key="Indexcon"> 
                                            <span data-testid="financialclose-project-users__default-progress-wrapper"  v-if="sub.hasOwnProperty(country)" > 
                                                <div v-if="sub?.isOverdue ">
                                                <div v-if="sub[country] === 100">
                                                    <v-chip data-testid="financialclose-project-users__progress-chip" color="green lighten-4" class="ml-0 mr-2 black--text height-24"
                                                label
                                               >
                                                <span>{{sub[country]}} %</span>
                                                </v-chip>
                                                </div>
                                                <div v-else-if="sub.duedate === todayDate">
                                                <v-chip data-testid="financialclose-project-users__progress-chip"
                                                :color="sub?.isOverdue ?  'light-blue lighten-4' : ''"
                                                class="ml-0 mr-2 black--text height-24"
                                                label
                                               
                                                >
                                                <span>{{sub[country]}} %</span>
                                                </v-chip> 
                                                </div>
                                                <div v-else>
                                                <v-chip data-testid="financialclose-project-users__progress-chip"
                                                :color="sub?.isOverdue ?  'red lighten-4' : ''"
                                                class="ml-0 mr-2 black--text height-24"
                                                label
                                               
                                                >
                                            <span>{{sub[country]}} %</span>
                                                </v-chip> 
                                                </div>
                                                
                                                </div>
                                                <div v-else>
                                                {{sub[country]}} %
                                                </div>
                                            </span> 
                                            <span data-testid="financialclose-project-users__default-na" v-else class=""> NA </span></td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                                </div>
                                


                            </v-col>

                            <!-- Empty state when filters are applied but no data is returned -->
                            <v-col data-testid="financialclose-project-users__filter-empty-state" cols="12" 
                                v-if="hasActiveFilter && deshbordTable.length === 0 && !loading" 
                                class="d-flex justify-center">
                                <div class="empty-state pa-8 text-center">
                                    <v-icon size="64" class="mb-4 grey--text text--lighten-1">mdi-filter-off-outline</v-icon>
                                    <div class="grey--text text--darken-1 title">No data to show</div>
                                    <div class="grey--text caption mt-2">Try adjusting your filters to see results</div>
                                </div>
                            </v-col>

                             <v-col data-testid="financialclose-project-users__flattened-summary" cols="12" v-if="deshbordTable.length > 0" class="d-flex justify-center">
                                <div data-testid="financialclose-project-users__flattened-summary-container" class="radius-on flattened-table-container">
                                    
                                    <v-simple-table data-testid="financialclose-project-users__flattened-table" dense class="border-on flattened-table">
                                <thead class="tableHeaderBg">
                                <tr>
                                    <th data-testid="financialclose-project-users__flattened-th-category" class="">Category</th>
                                    <th data-testid="financialclose-project-users__flattened-th-subcategory" class="">Subcategory</th>
                                    <th data-testid="financialclose-project-users__flattened-th-pending-submission" class=""> Pending Submission </th>
                                    <th data-testid="financialclose-project-users__flattened-th-pending-approval" class=""> Pending Approval </th>
                                    <th data-testid="financialclose-project-users__flattened-th-closed" class="">Closed Tasks</th>
                                    <th data-testid="financialclose-project-users__flattened-th-total" class="">Total</th>
                                    <th data-testid="financialclose-project-users__flattened-th-progress" class="">Progress Percentage</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr data-testid="financialclose-project-users__flattened-row" v-for="(item, index) in flattenedData" :key="index">
                                    <td data-testid="financialclose-project-users__flattened-cell-category">{{ item.category }}</td>
                                    <td data-testid="financialclose-project-users__flattened-cell-subcategory">{{ item.subcategory }}</td>
                                    <td data-testid="financialclose-project-users__flattened-cell-pending-submission">{{ item.pendingTasks }}</td>
                                    <td data-testid="financialclose-project-users__flattened-cell-pending-approval">{{ item.awaitingTasks }}</td>
                                    <td data-testid="financialclose-project-users__flattened-cell-closed">{{ item.completedTasks }}</td>
                                    <td data-testid="financialclose-project-users__flattened-cell-total">{{ item.totalTasks }}</td>
                                    <td data-testid="financialclose-project-users__flattened-cell-progress">{{ item.progressPercentage }} %</td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                                 
                                </div>
                            </v-col> 
                        </v-row>
                    </div>
                    <div data-testid="financialclose-project-users__empty-state" v-if="!initialLoading && !metadata._id && !loading" class="grey--text title text-center pa-8">
                        No Summary found
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <lb-dialog data-testid="financialclose-project-users__setup-dialog" v-model="showDialogue" width="500">
            <template v-slot:body>
                <div class="">
                    <v-row>
                        <v-col>
                            <div data-testid="financialclose-project-users__setup-dialog-text" class="text-body-1">Let us get started on setting up a close cycle</div>
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template v-slot:actions>
                <v-spacer></v-spacer>
                <div class="">
                    <v-row>
                        <v-col class="ma-2 pa-2">
                            <!-- <v-btn @click="$nova.gotoLink({ path: '/financialclose/project/checklist/' +id })">
                      <span>Skip this for now</span>
                    </v-btn> -->
                            <v-btn data-testid="financialclose-project-users__setup-dialog-get-started-btn" color="primary "
                                @click="$nova.gotoLink({ path: '/financialclose/project/trialbalance/' + id })">
                                <span>Get Started</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </lb-dialog>
       <v-dialog data-testid="financialclose-project-users__email-form-dialog" v-model="addeditemail" max-width="800" persistent>
    <v-card data-testid="financialclose-project-users__email-form-card" :loading="addeditemailloading" :disabled="addeditemailloading" loader-height="2" class="">
        <v-card-text data-testid="financialclose-project-users__email-form-header" class="tableHeaderBg d-flex align-center py-2 px-4">
            <p class="" v-if="emaildetails._id">Update Email Notification</p>
          <p class="" v-else>Add Email Notification</p>
            <v-spacer></v-spacer>
            <v-btn data-testid="financialclose-project-users__email-form-close-btn" icon @click="addeditemail = false; resetEmailErrors()" class="ml-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-text>
        <v-card-text data-testid="financialclose-project-users__email-form-body" class="mt-4 pt-4">
            <v-row>
                <v-col cols="6" class="my-0 py-1">
                    <lb-date 
                        data-testid="financialclose-project-users__email-start-date" 
                        v-model="emaildetails.startDate" 
                        label="Start Date*" 
                        :min="$nova.formatDateISO(new Date())" 
                        :error="emaildetailsErrors.startDate ? [emaildetailsErrors.startDate] : []"
                        @change="emaildetailsErrors.startDate = ''"
                    />
                </v-col>
                <v-col cols="6" class="my-0 py-1">
                    <lb-date 
                        data-testid="financialclose-project-users__email-end-date" 
                        v-model="emaildetails.endDate" 
                        label="End Date*" 
                        :min="emaildetails.startDate" 
                        :error="emaildetailsErrors.endDate ? [emaildetailsErrors.endDate] : []"
                        @change="emaildetailsErrors.endDate = ''"
                    />
                </v-col>
                <v-col cols="12" class="my-0 py-1">
                    <lb-tagsInput 
                        data-testid="financialclose-project-users__email-addresses" 
                        tagcolor="purpleborder" 
                        :multiple="true" 
                        v-model="emaildetails.emails" 
                        :multiplechips="true" 
                        label="Email Address*" 
                        outline 
                        :error="invalidEmails.length > 0 ? invalidEmails : (emaildetailsErrors.emails ? [emaildetailsErrors.emails] : [])"
                        @input="emaildetailsErrors.emails = ''"
                    />
                </v-col>
                <v-col cols="12" class="my-0 py-1">
                    <lb-string 
                        data-testid="financialclose-project-users__email-subject" 
                        label="Email Subject*" 
                        v-model="emaildetails.subject" 
                        :error="emaildetailsErrors.subject ? [emaildetailsErrors.subject] : []"
                        @input="emaildetailsErrors.subject = ''"
                    />
                </v-col>
                <v-col cols="12" class="my-0 py-1">
                    <lb-textarea 
                        data-testid="financialclose-project-users__email-body" 
                        label="Email Body*" 
                        v-model="emaildetails.mailBody" 
                        :error="emaildetailsErrors.mailBody ? [emaildetailsErrors.mailBody] : []"
                        @input="emaildetailsErrors.mailBody = ''"
                    />
                </v-col>
                <v-col cols="6" class="my-0 py-1" v-if="LocationsList.length">
                <lb-dropdown 
                    data-testid="financialclose-project-users__email-locations"
                    label="Location*"
                    multiple
                    v-model="emaildetails.locations"
                    :items="selectAllLocations"
                    itemtext="name"
                    itemvalue="id"
                    @change="(val) => { handleEmailLocationSelectAll(val); emaildetailsErrors.locations = ''; }"
                    :error="emaildetailsErrors.locations ? [emaildetailsErrors.locations] : []"
                />
                </v-col>
                <v-col cols="6" class="my-0 py-1">
                    <lb-dropdown 
                        data-testid="financialclose-project-users__email-hour" 
                        label="Hour*" 
                        v-model="emaildetails.time" 
                        :items="timeList" 
                        @change="(val) => { generateTimeMultiples(val); emaildetailsErrors.time = ''; }"
                        :error="emaildetailsErrors.time ? [emaildetailsErrors.time] : []"
                    />
                </v-col>
                <v-col cols="12" class="pt-0" v-if="timeMultiples.length">
                <p class="ma-0">Next 5 Triggers</p>
                <ul class="d-flex flex-wrap" style="list-style: none; padding-left: 0;">
                  <li data-testid="financialclose-project-users__email-next-trigger" class="me-4" v-for="(time, index) in timeMultiples" :key="index">
                    {{ time }}
                  </li>
                </ul>
              </v-col>
              <v-col cols="12" class="my-0 py-1">
                <div data-testid="financialclose-project-users__email-schedule-notice" class="error--text">{{ notificationMessages.SCHEDULE_UPDATE_NOTICE }}</div>
              </v-col>
            </v-row>
        </v-card-text>
        <v-card-text data-testid="financialclose-project-users__email-form-actions" class="d-flex">
            <v-spacer></v-spacer>

            <v-btn data-testid="financialclose-project-users__email-update-btn" color="primary" v-if="emaildetails._id" @click="updateemails()"><span>Update</span></v-btn>
            <v-btn data-testid="financialclose-project-users__email-create-btn" color="primary" v-else @click="addemails()"><span>Create</span></v-btn>
        </v-card-text>
    </v-card>
</v-dialog>
<lb-dialog data-testid="financialclose-project-users__email-list-dialog" v-model="emailpopdia" heading="Email Notifications" width="1000" :loading="emailpopdialoading">
    <template v-slot:body>
        <div data-testid="financialclose-project-users__email-list-header" class="d-flex justifySpaceBetween boldText">
            <div data-testid="financialclose-project-users__email-inactive-msg" v-if="isCycleInActive" >New notifications cannot be created or modified as the current cycle is closed.</div>
            <v-spacer v-else ></v-spacer>
            <v-btn data-testid="financialclose-project-users__add-email-btn" small color="primary" :disabled="isCycleInActive" @click="addeditemailFun()"><span>Add</span></v-btn>
        </div>
        <div>
            <v-simple-table data-testid="financialclose-project-users__email-table" class="pbc-view-table mt-2" dense v-if="emaildata.length > 0">
                <thead class="tableHeaderBg">
                    <tr>
                        <th data-testid="financialclose-project-users__email-th-index" scope="#" class="">#</th>
                        <th data-testid="financialclose-project-users__email-th-to" scope="columns">Email To</th>
                        <th data-testid="financialclose-project-users__email-th-location" scope="columns">Location</th>
                        <th data-testid="financialclose-project-users__email-th-created" scope="columns">Created At</th>
                        <th data-testid="financialclose-project-users__email-th-action" scope="Action" class="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                        <tr v-for="(v, k) in emaildata" :key="k" data-testid="financialclose-project-users__email-row">
                            <td data-testid="financialclose-project-users__email-cell-index">
                                <span data-testid="financialclose-project-users__email-index">{{ k + 1 }}</span>
                            </td>
                            <td data-testid="financialclose-project-users__email-cell-to" class="justify-center">
                                <div class="d-flex">
                                    <div class="d-flex">
                                        <v-chip data-testid="financialclose-project-users__email-to-chip" label v-if="v.meta.toUsers.length > 0" style="background: #f4e7d1;">
                                            <span>{{v.meta.toUsers[0]}}</span>
                                        </v-chip>
                                        <v-tooltip top content-class="tooltip-top" v-if="v.meta.toUsers.length > 1">
                                            <template v-slot:activator="{ on }">
                                                <v-avatar data-testid="financialclose-project-users__email-to-more" v-on="on" size="25" color="lime lighten-1" class="align-center">
                                                    <v-icon color="white">mdi-plus</v-icon>
                                                </v-avatar>
                                            </template>
                                            <div class="" v-for="(email, index) in v.meta.toUsers" :key="index">
                                                <span>{{ email }}</span>
                                            </div>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </td>
                            <td data-testid="financialclose-project-users__email-cell-location">
                                <template v-if="getValidLocationKeys(v.meta.location_key).length > 3">
                                    <span v-for="(location, k) in getValidLocationKeys(v.meta.location_key).slice(0, 3)" :key="k">  
                                <v-chip data-testid="financialclose-project-users__email-location-chip" label class="ml-2">
                                    <span>{{ getLocationName(location) }}</span>
                                </v-chip>
                                </span>

                                    <v-tooltip top content-class="tooltip-top">
                                        <template v-slot:activator="{ on }">
                                            <v-chip data-testid="financialclose-project-users__email-location-more" label class="ml-2" v-on="on">
                                                <span>+{{ getValidLocationKeys(v.meta.location_key).length - 3 }}</span>
                                            </v-chip>
                                        </template>
                                        <div v-for="(location, k) in getValidLocationKeys(v.meta.location_key).slice(3)" :key="k">
                                            <span>{{ getLocationName(location) }}</span>
                                        </div>
                                    </v-tooltip>
                                </template>
                                <template v-else>
                                    <span v-for="(location, k) in getValidLocationKeys(v.meta.location_key)" :key="k">  
                                <v-chip data-testid="financialclose-project-users__email-location-chip" label class="ml-2">
                                    <span>{{ getLocationName(location) }}</span>
                                </v-chip>
                                </span>
                                </template>
                            </td>
                            <td data-testid="financialclose-project-users__email-cell-created">
                                <span data-testid="financialclose-project-users__email-created">{{ $nova.formatDate(v.created_at) }}</span>
                            </td>
                            <td data-testid="financialclose-project-users__email-cell-actions" class="text-center">
                                <div class="d-flex align-center justify-center">
                                <v-tooltip bottom content-class="tooltip-bottom" v-if="v.flag">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn data-testid="financialclose-project-users__email-disable-btn" icon v-bind="attrs" v-on="on" color="success" :disabled="isCycleInActive" @click="enableDisableemails(v, 'disabled')">
                                            <v-icon>mdi-check</v-icon>
                                        </v-btn>
                                    </template>
                                    Disable
                                </v-tooltip>
                                <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn data-testid="financialclose-project-users__email-enable-btn" icon v-bind="attrs" v-on="on" color="error" :disabled="isCycleInActive" @click="enableDisableemails(v, 'enabled')">
                                            <v-icon>mdi-close-circle</v-icon>
                                        </v-btn>
                                    </template>
                                    Enable
                                </v-tooltip>
                                <v-tooltip bottom content-class="tooltip-bottom">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn data-testid="financialclose-project-users__email-edit-btn" icon v-bind="attrs" v-on="on" :disabled="isCycleInActive" @click="editemails(v)">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    Edit
                                </v-tooltip>
                                <activity-log
                                    :resource-id="v._id" 
                                    data-testid="financialclose-project-users__email-activity-log-btn"
                                    row-description="Email Notification"
                                />
                                </div>
                            </td>
                        </tr>
                </tbody>
            </v-simple-table>
            <div data-testid="financialclose-project-users__email-empty" v-else class="text-center grey--text title pa-6">
                No data available
            </div>
        </div>
    </template>
</lb-dialog>
    </div>
</template>
<script>
import { EMAIL_NOTIFICATION , CRON, UI_TEXT} from '../../utils/constants';
import ActivityLog from '../../components/ActivityLog/ActivityLog.vue';

export default {
    name: 'financialclose_project_users',
    // props: ['props'],
    data: function () {
        return {
            UI_TEXT, // Make UI_TEXT available in template
            emailpopdia:false,
            emailpopdialoading:false,
            addeditemail:false,
            addeditemailloading:false,
            emaildetails:{
                locations: []
            },
            // Validation errors for email notification form
            emaildetailsErrors: {
                startDate: '',
                endDate: '',
                emails: '',
                subject: '',
                mailBody: '',
                locations: '',
                time: ''
            },
            // Loading states
            initialLoading: false, // For skeleton loader during initial data fetch
            locationMenuKey: 0, // For forcing menu re-render
            categoryTableItemsPerPage: 10, // Items per page for category summary table
            headers: [
                {
                    text: 'S no',
                    value: 'no',
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    text: 'Mail To',
                    value: 'email',
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    text: 'Created On',
                    value: 'created_at',
                    visible: false,
                    filterable: true,
                    sortable: true,
                },
                {
                    text: 'Action',
                    value: 'action',
                    visible: true,
                    filterable: false,
                    sortable: false,
                },],
            emaildata:[],
            loading: false,
            metadata: {},
            summary: {},
            color: {},
            keytypes: {},
            selected: "",
            categorydata: [],
            type: "percentcount",
            typetoggle: false,
            deshbordTable:[],
            selectedLocation: {},
            selectedUsers:{},
            activitylogconfig: {
                userassociate: {
                    icon: "mdi-plus",
                    color: "info",
                    displaytext: "User Associated",
                },
                userreplaced: {
                    icon: "mdi-account-convert",
                    color: "info",
                    displaytext: "User Replaced",
                },
                userremoved: {
                    icon: "mdi-close",
                    color: "error",
                    displaytext: "User Removed",
                },
                usermoved: { icon: "mdi-sync", color: "", displaytext: "Updated" },
                projectcreate: {
                    icon: "mdi-plus",
                    color: "info",
                    displaytext: "Created",
                },
                projectopen: {
                    icon: "mdi-lock-open-variant",
                    color: "info",
                    displaytext: "Opened",
                },
                projectclose: {
                    icon: "mdi-lock",
                    color: "success",
                    displaytext: "Closed",
                },
                projectupdated: {
                    icon: "mdi-pencil",
                    color: "primary",
                    displaytext: "Updated",
                },
                tbadd: {
                    icon: "mdi-table-plus",
                    color: "error",
                    displaytext: "Trial Balance Added",
                },
                bulkpbcadd: {
                    icon: "mdi-file-question-outline",
                    color: "",
                    displaytext: "Information Request Added",
                },
            },
            isFirst: false,
            showDialogue: false,
            tableheaders:[
                {
                    value: "_id",
                    text: "Category",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    text: "Pending Submission",
                    value : "pending",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    text: "Pending Approval",
                    value : "awaiting",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    value: "completed",
                    text: "Closed Task",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    
                    value: "total",
                    text: "Total",
                    sortable: false,
                    filterable: false,
                    visible:true,
                }
            ],
            tabledesh:[
                {
                    value: "category",
                    text: "Category",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    value: "subcategories",
                    text: "Subcategories",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    text: "Pending Submission",
                    value : "pending",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    text: "Pending Approval",
                    value : "awaiting",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    value: "completed",
                    text: "Closed Task",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    
                    value: "total",
                    text: "Total",
                    sortable: false,
                    filterable: false,
                    visible:true,
                },
                {
                    
                    value: "progressPercentage",
                    text: "Percentage",
                    sortable: false,
                    filterable: false,
                    visible:true,
                }
            ],
            tddata:[],      
            userdata:[],
            selectedLocationName:[],
            selectedUserName:{},
            selectedCOuntryname:{},
            LocationsList: [],
            timeList: EMAIL_NOTIFICATION.timeList,
            timeMultiples: [],
            countrylist:[],
            userlist:[],
            defaultabledata:[],
            todayDate:this.$nova.formatDate(this.$nova.getDate(),'YYYY-MM-DD'),
            clientNotification:false,
            isCycleInActive:false,
            notificationMessages: EMAIL_NOTIFICATION.MESSAGES,
            activeUserIds:[],
        }
    },
    components: {
     ActivityLog
    },
    created() {
        this.$store.dispatch('tasks/ensureFilteredLocations', { cycleId: this.$route.params.id });
        this.refreshData();
    },
    activated() {
        this.refreshData();
    },
    methods: {
        selectAllCountries() {
            this.selectedCOuntryname = { country: 'All' };
            this.selectedLocationName = [];
            this.getData();
        },
        selectAllUsers() {
            this.selectedUserName = { name: 'All' };
            this.filterWithAllUsers();
        },
        filterWithAllUsers() {
            this.loading = true;
            const locationIds = this.selectedLocationName.length > 0 
                ? this.selectedLocationName.map(loc => loc.id)
                : [];
            
            const filters = { 
                location: locationIds,
                user: [] // Empty array means all users
            };
            
            this.$store.dispatch('dashboard/getDashboardV3', {
                cycleId: this.id,
                filters
            }).then((result) => {
                if (result.success) {
                    this.deshbordTable = result.data.categoryBreakdown || [];
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        toggleSelectAllLocations() {
            if (this.isAllLocationsSelected) {
                this.selectedLocationName = [];
            } else {
                // Use activeLocationsList to ensure only active locations are selected
                this.selectedLocationName = [...this.activeLocationsList];
            }
            this.filterMultipleLocations();
        },
        toggleLocationSelection(location) {
            const index = this.selectedLocationName.findIndex(loc => loc.id === location.id);
            if (index > -1) {
                this.selectedLocationName.splice(index, 1);
            } else {
                this.selectedLocationName.push(location);
            }
            this.filterMultipleLocations();
        },
        isLocationSelected(location) {
            return this.selectedLocationName.some(loc => loc.id === location.id);
        },
        filterMultipleLocations() {
            if (this.selectedLocationName.length === 0) {
                // If no locations selected, reset to show all
                this.getData();
                return;
            }
            
            this.loading = true;
            const locationIds = this.selectedLocationName.map(loc => loc.id);
            const filters = { 
                location: locationIds,
                user: this.selectedUserName?._id ? [this.selectedUserName._id] : []
            };
            
            this.$store.dispatch('dashboard/getDashboardV3', {
                cycleId: this.id,
                filters
            }).then((result) => {
                if (result.success) {
                    this.deshbordTable = result.data.categoryBreakdown || [];
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        handleSelectAll(selected) {
        const allIds = this.LocationsList?.map(item => item.id.toString()) || [];
        const hasSelectAll = selected.includes('select_all');
        if (hasSelectAll) {
            const selectedWithoutSelectAll = selected.filter(id => id !== 'select_all').map(id => id.toString());
            const isAllSelected = selectedWithoutSelectAll.length === allIds.length &&
                                allIds.every(id => selectedWithoutSelectAll.includes(id));
            this.emaildetails.locations = isAllSelected ? [] : [...allIds];
        } else {
            this.emaildetails.locations = selected.filter(id => id !== 'select_all').map(id => id.toString());
        }
        },
        /**
         * Handle select all for email location dropdown
         * Similar to category select all behavior
         * @param {Array} selected - Selected location IDs
         */
        handleEmailLocationSelectAll(selected) {
            const allIds = this.LocationsList?.map(item => (item.id?.toString() || item._id?.toString())) || [];
            const hasSelectAll = selected.includes('select_all');
            
            if (hasSelectAll) {
                const selectedWithoutSelectAll = selected.filter(id => id !== 'select_all').map(id => id.toString());
                const isAllSelected = selectedWithoutSelectAll.length === allIds.length &&
                                    allIds.every(id => selectedWithoutSelectAll.includes(id));
                // Toggle: if all selected, deselect all; otherwise select all
                this.emaildetails.locations = isAllSelected ? [] : [...allIds];
            } else {
                this.emaildetails.locations = selected.filter(id => id !== 'select_all').map(id => id.toString());
            }
        },
        generateTimeMultiples(selectedHour) {
            const baseHour = parseInt(selectedHour);
            if (isNaN(baseHour)) {
                this.timeMultiples = [];
                return;
            }
            const getGMTOffset = (date) => {
                const offset = -date.getTimezoneOffset(); // In minutes
                const sign = offset >= 0 ? '+' : '-';
                const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
                const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
                return `GMT${sign}${hours}:${minutes}`;
            };
            const baseUTC = new Date();
            baseUTC.setUTCHours(0, 0, 0, 0);
            this.timeMultiples = Array.from({ length: 5 }, (_, i) => {
                const timeUTC = new Date(baseUTC.getTime());
                timeUTC.setUTCDate(baseUTC.getUTCDate() + i);      
                timeUTC.setUTCHours(baseHour, 0, 0, 0);       
                const localDate = new Date(timeUTC);
                const year = localDate.getFullYear();
                const month = String(localDate.getMonth() + 1).padStart(2, '0');
                const day = String(localDate.getDate()).padStart(2, '0');
                const hours = String(localDate.getHours()).padStart(2, '0');
                const minutes = String(localDate.getMinutes()).padStart(2, '0');
                const seconds = String(localDate.getSeconds()).padStart(2, '0');
                const timezone = getGMTOffset(localDate);
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${timezone}`;
            });
            },
        /**
         * Get location name by ID, supports both 'id' and '_id' properties
         * @param {string|number} locationId - Location ID to look up
         * @returns {string|null} - Location name or null if not found
         */
        getLocationName(locationId) {
      if (!locationId) return null;
      const locIdStr = String(locationId);
      const location = this.LocationsList.find(
        (loc) => String(loc.id) === locIdStr || String(loc._id) === locIdStr
      );
      return location ? location.name : null;
    },
        /**
         * Filter location keys to only include valid ones that exist in LocationsList
         * @param {Array} locationKeys - Array of location IDs
         * @returns {Array} - Filtered array of valid location IDs
         */
        getValidLocationKeys(locationKeys) {
            if (!locationKeys || !Array.isArray(locationKeys)) return [];
            return locationKeys.filter(locId => this.getLocationName(locId) !== null);
        },  
        getClientNotification(){
            // V3: Client notification (schedulerEnabled) is fetched via getFormDataV3 in refreshData.
            // This method is kept for backward compatibility but is now a no-op.
        }, 
        filterselectedloactionanduser(enitit,country,user){
            let enitits = enitit?.locations?.map((item)=> item.id);
            this.loading = true;
            const filters = { 
                location: enitits && (enitits?.length > 0) ? enitits : [],
                user: user?._id ? [user._id] : []
            };
            
            this.$store.dispatch('dashboard/getDashboardV3', {
                cycleId: this.id,
                filters
            }).then((result) => {
                if (result.success) {
                    this.deshbordTable = result.data.categoryBreakdown || [];
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * Filter by selected location
         * @param {Object} item - Selected location
         * @param {Object} user - Selected user (optional)
         */
        filterselectedloaction(item, user) {
            this.loading = true;
            const filters = { 
                location: item ? [item.id] : [],
                user: user?._id ? [user._id] : []
            };
            
            this.$store.dispatch('dashboard/getDashboardV3', {
                cycleId: this.id,
                filters
            }).then((result) => {
                if (result.success) {
                    this.deshbordTable = result.data.categoryBreakdown || [];
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * Filter by all locations in a country
         * @param {Object} country - Selected country with locations
         * @param {Object} user - Selected user (optional)
         */
        filterAllloaction(country, user) {
            // Filter only active locations, guarding against missing locations
            const activeLocations = (country?.locations || []).filter(loc => loc.status !== false);
            const ids = activeLocations.map(item => item.id);
            
            const filters = { 
                location: ids.length > 0 ? ids : [], 
                user: user?._id ? [user._id] : []
            };
            
            this.loading = true;
            this.$store.dispatch('dashboard/getDashboardV3', {
                cycleId: this.id,
                filters
            }).then((result) => {
                if (result.success) {
                    this.deshbordTable = result.data.categoryBreakdown || [];
                    this.selectedLocationName = [];
                    // Only include active locations
                    this.LocationsList = activeLocations;
                    this.locationMenuKey++;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        getNameById(id) {
            let userName = this.userdata.find((location) => location._id === id)
            return userName ? userName.name : ""
        },
        /**
         * Refresh all dashboard data
         * Uses skeleton loader for initial load and properly sequences API calls
         */
        async refreshData() {
            this.id = this.$route.params.id || "";
            this.userid = this.$store.state.user.id;
            this.selected = "";
            this.initialLoading = true;
            this.selectedLocationName = [];
            this.selectedUserName = {};
            this.selectedCOuntryname = {};
            this.LocationsList = [];
            this.countrylist = [];
            this.userlist = [];
            this.deshbordTable = [];
            this.metadata = {};
            this.summary = {};
            
            // Set up keytypes
            this.keytypes = {
                "income": { name: "Income", color: this.$nova.hexToRgbA("#37AE78") },
                "expense": { name: "Expense", color: this.$nova.hexToRgbA("#E85B61") },
                "asset": { name: "Assets", color: this.$nova.hexToRgbA("#4285F4") },
                "liability": { name: "Liabilities", color: this.$nova.hexToRgbA("#AF52DE") },
                "equity": { name: "Equity", color: this.$nova.hexToRgbA("#30B0C7") },
                "other": { name: "Others", color: this.$nova.hexToRgbA("#5856D6") },
            };
            
            try {
                // V3: Fetch formdata + dashboard in parallel via initializeDashboardV3
                const initResult = await this.$store.dispatch('dashboard/initializeDashboardV3', { cycleId: this.id });

                if (initResult.success) {
                    // Process form data (users + locations)
                    const formData = initResult.formData?.data;
                    if (formData) {
                        // Build userdata and userlist from v3 formdata
                        this.userdata = formData.users || [];
                        this.activeUserIds = (formData.users || []).filter(u => u.isActive).map(u => u._id);
                        this.userlist = this.userdata.filter(u => this.activeUserIds.includes(u._id));

                        // Build country/location lists from v3 formdata locations
                        const locationsByCountry = {};
                        for (const loc of (formData.locations || [])) {
                            const country = loc.country || 'Unknown';
                            if (!locationsByCountry[country]) {
                                locationsByCountry[country] = { country, locations: [] };
                            }
                            locationsByCountry[country].locations.push({
                                id: loc._id,
                                name: loc.name,
                                status: true,
                            });
                        }
                        this.countrylist = Object.values(locationsByCountry);
                        this.LocationsList = this.countrylist
                            .map(item => item.locations)
                            .flat()
                            .filter(loc => loc.status !== false);
                        this.locationMenuKey++;

                        // Scheduler enabled
                        this.clientNotification = formData.schedulerEnabled || false;
                    }

                    // Process dashboard data
                    const dashData = initResult.dashboard?.data;
                    if (dashData) {
                        this._processDashboardData(dashData);
                    }
                }
            } catch (error) {
                console.error('[Dashboard]: refreshData error', error);
                this.$store.commit("sbError", error.message || "Failed to load dashboard data");
            } finally {
                this.initialLoading = false;
            }
        },
        /**
         * Process dashboard API response and update component state.
         * Shared by refreshData (initial load) and getData (filter reset/refresh).
         * @param {Object} data - Response from getDashboardV3: { metadata, summary, categoryBreakdown }
         */
        _processDashboardData(data) {
            this.metadata = data.metadata || {};
            this.summary = data.summary || {};
            this.managerlist = this.metadata.managerlist || [];
            this.stage = this.metadata.stage;

            // is-first-cycle check
            if (!this.metadata.hasChecklist && !this.metadata.tbInitialized) {
                this.isFirst = true;
            } else {
                this.isFirst = false;
            }

            // tddata for GL type reference (using tbInitialized as proxy)
            this.tddata = this.metadata.tbInitialized ? [{ _placeholder: true }] : [];
            if (this.tddata.length === 0) {
                this.selected = 'other';
            }

            // Process category breakdown (default dashboard data)
            this.defaultabledata = this.deshbordFun(data.categoryBreakdown || []);
        },
        /**
         * Refresh only dashboard data (no formdata reload).
         * Used after filter resets and country/user selection changes.
         */
        async getData() {
            this.loading = true;
            this.summary = {};

            try {
                const result = await this.$store.dispatch('dashboard/getDashboardV3', { cycleId: this.id });
                if (result.success && result.data) {
                    this._processDashboardData(result.data);
                }
            } catch (err) {
                console.error('[Dashboard]: getData error', err);
                this.$store.commit("sbError", err.message || "Unknown error loading dashboard!");
            } finally {
                this.loading = false;
            }
        },
        getSubcategories(countries) {
      // Flatten all subcategories across countries
      const allSubcategories = [];
      for (const countryData of Object.values(countries)) {
        countryData.forEach((sub) => {
          if (!allSubcategories.find((s) => s.subcategory === sub.subcategory)) {
            allSubcategories.push(sub);
          }
        });
      }
      return allSubcategories;
    },
        /**
         * Process dashboard data and build country-wise summary
         * Filters out disabled countries based on location status
         * @param {Array} data - Dashboard data from API
         * @returns {Array} - Processed data for display
         */
        deshbordFun(data) {
            // Get active countries only (countries with at least one active location)
            const activeCountryList = this.countrylist.filter(country => 
                country.locations?.some(loc => loc.status !== false)
            );
            
            this.uniqueCountries = [...new Set(
                activeCountryList.map(item => item.country)
                    .filter(country => typeof country === 'string' && country.trim() !== '')
            )].sort((a, b) => a.localeCompare(b));
            
            const result = [];
            const dynamicCountries = new Set();
            data.forEach(item => {
                dynamicCountries.add(item.country);
            });

            // Only process data for active countries
            data.forEach(item => {
                const { category, country, subcategories } = item;
                
                // Skip if country is disabled
                if (!this.uniqueCountries.includes(country)) {
                    return;
                }
                
                let categoryEntry = result.find(entry => entry.category === category);

                if (!categoryEntry) {
                    categoryEntry = { 
                        category, 
                        subcategories: [] 
                    };
                    result.push(categoryEntry);
                }

                subcategories.forEach(sub => {
                    let subcategoryEntry = categoryEntry.subcategories.find(
                        s => s["subcategory"] === sub.subcategory
                    );

                    if (!subcategoryEntry) {
                        subcategoryEntry = {
                            "subcategory": sub.subcategory,
                            "duedate": sub?.lastDueDate?.split("T")[0], 
                            "isOverdue": sub.isOverdue,
                        };
                        categoryEntry.subcategories.push(subcategoryEntry);
                    }
                    subcategoryEntry[country] = sub.progressPercentage;  
                });
                
                categoryEntry.subcategories.sort((a, b) => {
                    const dateA = new Date(a["duedate"]);
                    const dateB = new Date(b["duedate"]);
                    return dateA - dateB; // Ascending order (older first)
                });
            });

            return result;
        },

        groupByCountry(data) {
            return data.reduce((acc, { _id, country }) => {
                if (country != null && country !== "" && !Array.isArray(country)) {
                    const existingCountry = acc.find(item => item.country === country);
                    if (existingCountry) {
                        existingCountry._id.push(_id); 
                    } else {
                        acc.push({ country, _id: [_id] });
                    }
                }

                return acc;
            }, []);
        },
        setUpCloseCycle() {
            this.showDialogue = true;

        },
        filterWithLocation(location) {
            this.selectedLocation = location;
            this.getLocationFilter();
        },
        /**
         * Reset all filters and reload data
         */
        resetFilter() {
            this.selectedLocation = {};
            this.selectedUserName = {};
            this.selectedLocationName = [];
            this.selectedCOuntryname = {};
            this.deshbordTable = [];
            this.locationMenuKey++; // Force menu re-render
            this.getData();
        },
        getLocationFilter() {
            this.summary = {};
            this.loading = true;
            
            this.$store.dispatch('dashboard/getDashboardV3', {
                cycleId: this.id,
                filters: { location: [this.selectedLocation._id], user: [] }
            }).then((result) => {
                if (result.success) {
                    let data = result.data || {};
                    this.metadata = data.metadata || {};
                    this.summary = data.summary || {};
                    this.managerlist = [];
                    this.managerlist = this.metadata.managerlist || [];
                    this.stage = this.metadata.stage;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        emailpop() {
           this.emailpopdia = true;
           this.emailpopdialoading = true;
           this.$store.dispatch('dashboard/getAllEmailNotifications', {
               cycleId: this.id,
               notificationType: EMAIL_NOTIFICATION.FEATURE_TYPES.DASHBOARD
           }).then((data) => {
               this.emaildata = data;
               this.isCycleInActive = this.$store.getters['dashboard/isCycleInActive'];
           }).finally(() => {
               this.emailpopdialoading = false;
           });
        },
        addeditemailFun() {
            if (this.$store.getters['dashboard/isMaxNotificationsReached']) {
                this.$store.commit(
                "sbError",
                this.notificationMessages.MAX_NOTIFICATIONS_ERROR
                );
                return;
            }
            this.addeditemail = true;
            this.emaildetails = { locations: [] };
            this.resetEmailErrors();
        },
       editemails(item) {
        this.addeditemail = true;
        this.resetEmailErrors();
        this.emaildetails = {
            _id: item._id || null,
            subject: item.subject || '',
            mailBody: item.mailBody || '',
            time: CRON.cronFormatToHour(item.schedulerTiming.toString() || ''),
            startDate: item.meta?.startDate || '',
            endDate: item.meta?.endDate || '',
            emails: Array.isArray(item.meta?.toUsers) ? [...item.meta.toUsers] : [],
            locations: Array.isArray(item.meta?.location_key)
            ? [...item.meta.location_key.map(l => l.toString())]
            : [],
        };
        },
       addemails() {
           // Validate required fields before submission
           if (!this.validateEmailNotificationFields()) {
               return;
           }
           
           this.addeditemailloading = true;
           // Filter out invalid/unknown locations before sending
           const validLocations = this.getValidLocationKeys(this.emaildetails.locations);
           this.$store.dispatch('dashboard/addEmailNotification', {
               cycleId: this.id,
               notificationData: {
                   subject: this.emaildetails.subject,
                   mailBody: this.emaildetails.mailBody,
                   time: this.emaildetails.time,
                   locations: validLocations,
                   emails: this.emaildetails.emails,
                   startDate: this.emaildetails.startDate,
                   endDate: this.emaildetails.endDate
               }
           }).then((result) => {
               if (result.success) {
                   this.addeditemail = false;
                   this.emailpop(); // Refresh email notifications list
               }
           }).finally(() => {
               this.addeditemailloading = false;
           });
       },
       isValidEmail(email) {
           const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
           return emailRegex.test(email);
       },
       /**
        * Reset email form validation errors
        */
       resetEmailErrors() {
           this.emaildetailsErrors = {
               startDate: '',
               endDate: '',
               emails: '',
               subject: '',
               mailBody: '',
               locations: '',
               time: ''
           };
       },
       /**
        * Validate email notification form fields
        * @returns {boolean} - True if all required fields are valid
        */
       validateEmailNotificationFields() {
           this.resetEmailErrors();
           let isValid = true;
           const details = this.emaildetails;
           const errors = this.emaildetailsErrors;
           
           // Start Date validation
           if (!details.startDate) {
               errors.startDate = 'Start Date is required';
               isValid = false;
           }
           
           // End Date validation
           if (!details.endDate) {
               errors.endDate = 'End Date is required';
               isValid = false;
           } else if (details.startDate && new Date(details.endDate) < new Date(details.startDate)) {
               errors.endDate = 'End Date must be after Start Date';
               isValid = false;
           }
           
           // Email addresses validation
           if (!details.emails || details.emails.length === 0) {
               errors.emails = 'At least one email address is required';
               isValid = false;
           } else if (this.invalidEmails.length > 0) {
               errors.emails = 'Please enter valid email addresses';
               isValid = false;
           }
           
           // Subject validation
           if (!details.subject || details.subject.trim() === '') {
               errors.subject = 'Email Subject is required';
               isValid = false;
           }
           
           // Mail Body validation
           if (!details.mailBody || details.mailBody.trim() === '') {
               errors.mailBody = 'Email Body is required';
               isValid = false;
           }
           
           // Hour validation
           if (details.time === null || details.time === undefined || details.time === '' || (Array.isArray(details.time) && details.time.length === 0)) {
               errors.time = 'Hour is required';
               isValid = false;
           }
           
           // Location validation
           if (!details.locations || details.locations.length === 0) {
               errors.locations = 'At least one location is required';
               isValid = false;
           }
           
           if (!isValid) {
               this.$store.commit('sbError', EMAIL_NOTIFICATION.MESSAGES.REQUIRED_VALIDATION);
           }
           
           return isValid;
       },
       updateemails() {
           // Validate required fields before submission
           if (!this.validateEmailNotificationFields()) {
               return;
           }
           
           this.addeditemailloading = true;
           // Filter out invalid/unknown locations before sending
           const validLocations = this.getValidLocationKeys(this.emaildetails.locations);
           
           this.$store.dispatch('dashboard/updateEmailNotification', {
               cycleId: this.id,
               notificationData: {
                   _id: this.emaildetails._id,
                   subject: this.emaildetails.subject,
                   mailBody: this.emaildetails.mailBody,
                   time: this.emaildetails.time,
                   locations: validLocations,
                   emails: this.emaildetails.emails,
                   startDate: this.emaildetails.startDate,
                   endDate: this.emaildetails.endDate
               }
           }).then((result) => {
               if (result.success) {
                   this.addeditemail = false;
                   this.emailpop(); // Refresh email notifications list
               }
           }).finally(() => {
               this.addeditemailloading = false;
           });
       },
       enableDisableemails(item, type) {
           this.emailpopdialoading = true;
           const isEnabled = type.trim() === 'enabled';
           this.$store.dispatch('dashboard/toggleEmailNotificationStatus', {
               cycleId: this.id,
               notification: item,
               enable: isEnabled,
               isEnableDisable: true,
           }).then(() => {
               this.emailpop(); // Refresh email notifications list
           }).finally(() => {
               this.emailpopdialoading = false;
           });
       },
       // convertToCronTime has been moved to constants.js as CRON.hourToCronFormat
       
       /**
        * Check if a location is disabled based on status from API
        * @param {string} locationId - Location ID to check
        * @returns {boolean} - True if location is disabled
        */
       isLocationDisabled(locationId) {
           return this.$store.getters['dashboard/isLocationDisabled'](locationId);
       },
       
       /**
        * Check if a country is disabled (all locations disabled)
        * @param {string} countryName - Country name to check
        * @returns {boolean} - True if country is disabled
        */
       isCountryDisabled(countryName) {
           return this.$store.getters['dashboard/isCountryDisabled'](countryName);
       },
    },
    computed: {
        filteredLocationsFromStore() {
          return this.$store.getters['tasks/getFilteredLocations'] || [];
        },
        /**
         * Get list of active countries (at least one active location)
         */
        activeCountryList() {
            if (!this.countrylist) return [];
            return this.countrylist.filter(country => {
                // Check if at least one location is active
                return country.locations?.some(loc => loc.status !== false);
            });
        },
        /**
         * Get list of active locations only
         */
        activeLocationsList() {
            return this.LocationsList.filter(loc => loc.status !== false);
        },
        /**
         * Display text for selected country filter
         */
        selectedCountryDisplayText() {
            if (!this.selectedCOuntryname || !Object.keys(this.selectedCOuntryname).length) {
                return 'All';
            }
            return this.selectedCOuntryname.country || 'All';
        },
        /**
         * Display text for selected user filter
         */
        selectedUserDisplayText() {
            if (!this.selectedUserName || !Object.keys(this.selectedUserName).length) {
                return 'All';
            }
            return this.selectedUserName.name || 'All';
        },
        /**
         * Display text for selected location filter
         */
        selectedLocationDisplayText() {
            if (this.selectedLocationName.length === 0) {
                return 'All';
            } else if (this.selectedLocationName.length === 1) {
                return this.selectedLocationName[0].name || 'NA';
            } else if (this.selectedLocationName.length === this.activeLocationsList.length) {
                return 'All Locations';
            } else {
                return `${this.selectedLocationName.length} Selected`;
            }
        },
        /**
         * Check if all locations are selected
         */
        isAllLocationsSelected() {
            return this.activeLocationsList.length > 0 && 
                   this.selectedLocationName.length === this.activeLocationsList.length;
        },
        /**
         * Check if any filter is active
         */
        hasActiveFilter() {
            return Object.keys(this.selectedCOuntryname).length > 0 ||
                   this.selectedLocationName.length > 0 ||
                   Object.keys(this.selectedUserName).length > 0;
        },
        selectAllLocations() {
        // Use LocationsList for consistency with handleSelectAll and getLocationName
        return [
            { id: 'select_all', name: UI_TEXT.SELECT_ALL },
            ...this.LocationsList.map(loc => ({
            ...loc,
            id: loc.id?.toString() || loc._id?.toString(), // Support both id and _id
            name: loc.name
            }))
        ];
        },
       invalidEmails() {
            if (this.emaildetails.emails) {
            return this.emaildetails.emails
                .filter(email => !this.isValidEmail(email))
                .map(email => `${email} is not a valid email.`);
            } else {
            return [];
            }       
        },
        flattenedData() {
            // Flatten the rawData into a single array of subcategories with categories
            return this.deshbordTable.flatMap((item) =>
                item.subcategories.map((subcategory) => ({
                category: item.category,
                ...subcategory,
                }))
            );
        },
        finaluserlist() {
            let nl = [];
            for (const i of this.managerlist) {
                let ud = { ...this.userdata[i] };
                ud.type = "manager";
                nl.push(ud);
            }
            for (const i of this.userlist) {
                let ud = { ...this.userdata[i] };
                ud.type = "general";
                nl.push(ud);
            }
            return nl;
        },
    },
    watch: {
        typetoggle: function (d) {
            if (d) this.type = "percentvalue"
            else this.type = "percentcount"
        }
    }
}
</script>
<style scoped lang="scss">
@import './Dashboard.scss';
</style>